import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "page d-flex flex-row flex-column-fluid" }
const _hoisted_2 = {
  id: "kt_wrapper",
  class: "wrapper d-flex flex-column flex-row-fluid"
}
const _hoisted_3 = { class: "content flex-row-fluid webtraderContent pt-3" }
const _hoisted_4 = {
  key: 0,
  id: "zendesk",
  class: "live-chat"
}
const _hoisted_5 = {
  href: "javascript:void(0)",
  style: {"color":"black"}
}

import { onMounted, watch, nextTick, ref } from "vue";
import { useStore } from "@/store";
import { useRoute, useRouter } from "vue-router";
import KTAside from "@/layouts/client-layout/aside/Aside.vue";
import KTHeader from "@/layouts/client-layout/header/Header.vue";
import KTFooter from "@/layouts/client-layout/footer/Footer.vue";
import HtmlClass from "@/core/services/LayoutService";
import KTToolbar from "@/layouts/client-layout/toolbar/Toolbar.vue";
import KTLoader from "@/components/Loader.vue";
import { Actions } from "@/store/enums/StoreEnums";
import { MenuComponent } from "@/assets/ts/components";
import { reinitializeComponents } from "@/core/plugins/plugins";
import { removeModalBackdrop } from "@/core/helpers/dom";
import {
  loaderEnabled,
  contentWidthFluid,
  loaderLogo,
  asideEnabled,
  themeLightLogo,
  themeDarkLogo,
} from "@/core/helpers/config";
import { canLiveChat } from "@/core/types/TenantTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientLayout',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();
const toolBarAction = ref<InstanceType<typeof KTToolbar>>();
const script = document.createElement("script");
script.src = "/js/zenChat.js?ver=1.0.1";

store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");

onMounted(() => {
  //check if current user is authenticated
  if (!store.getters.isUserAuthenticated) {
    router.push({
      name: "sign-in",
      query: { redirect: router.currentRoute.value.path },
    });
  }

  nextTick(() => {
    reinitializeComponents();
  });

  // initialize html element classes
  HtmlClass.init();

  // Simulate the delay page loading
  setTimeout(() => {
    // Remove page loader after some time
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
    document.head.appendChild(script);
  }, 500);
});

watch(
  () => route.path,
  () => {
    MenuComponent.hideDropdowns(undefined);

    // check if current user is authenticated
    if (!store.getters.isUserAuthenticated) {
      router.push({
        name: "sign-in",
        // query: { redirect: router.currentRoute.value.name },
      });
    }

    removeModalBackdrop();
    nextTick(() => {
      reinitializeComponents();
    });
  }
);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(loaderEnabled))
      ? (_openBlock(), _createBlock(KTLoader, {
          key: 0,
          logo: _unref(loaderLogo)
        }, null, 8, ["logo"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(KTHeader),
        _createVNode(KTToolbar, {
          ref_key: "toolBarAction",
          ref: toolBarAction
        }, null, 512),
        _createElementVNode("div", {
          id: "kt_content",
          class: _normalizeClass(["d-flex flex-column-fluid align-items-start", {
          'container-fluid': _unref(contentWidthFluid),
          'container-xxl': !_unref(contentWidthFluid),
        }])
        }, [
          (_unref(asideEnabled))
            ? (_openBlock(), _createBlock(KTAside, {
                key: 0,
                lightLogo: _unref(themeLightLogo),
                darkLogo: _unref(themeDarkLogo)
              }, null, 8, ["lightLogo", "darkLogo"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_view),
            (_unref(canLiveChat))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("a", _hoisted_5, [
                    _createVNode(_component_inline_svg, {
                      class: "me-2",
                      style: {"width":"16px"},
                      src: "/images/icons/other/livechat.svg"
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("action.chat")), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ], 2),
        _createVNode(KTFooter)
      ])
    ])
  ], 64))
}
}

})